
window.options.slickOptions.slidesToScroll = 4;
window.options.slickOptions.slidesToScroll_Tablet = 2;

window.options.chooseProduct.showOrderProcessingPopup = true;
